import { Component, Inject, OnInit } from '@angular/core';

import { SnLocation } from '@lib/api/entities';
import { SN_DRAWER_DATA } from '@lib/ui/drawer';

@Component({
  selector: 'sn-location-media-drawer',
  templateUrl: './location-media-drawer.component.html',
  styleUrls: ['./location-media-drawer.component.scss'],
})
export class LocationMediaDrawerComponent implements OnInit {
  constructor(@Inject(SN_DRAWER_DATA) public location: SnLocation) {}

  public ngOnInit(): void {}
}
